import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { isEmpty } from "lodash";
import Typography from '@mui/material/Typography';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Button from '@mui/material/Button';
import AddCircleIcon from "@mui/icons-material/AddCircle";
import ProjectForm from './ProjectForm';
import { Edit, CloudDownloadRounded, AddCircleRounded, NoteAddRounded, EngineeringRounded, AddRounded, Inventory2Rounded, FormatListBulletedRounded } from '@mui/icons-material';
import { IconButton, Grid, Box, Fab } from '@mui/material';
import ProjectSingle from './ProjectSingle';
import SearchBar from '../../common/SearchBar';
import AddSpending from './AddSpending';
import ProjectStepForm from './ProjectStepForm';
import TitleWithEndAction from '../../common/TitleWithEndAction';

class ProjectsList extends Component {
    state = { 
        page: 0,
        rowsPerPage: 10,
        openForm: false,
        openUpdate: false,
        openDetails: false,
        openAddSpending: false,
        newStep: false,
        selected: {},
        selectedProject: {},
        searchValue: "",
    }

    handleChangePage = (event, page) => {
        this.setState({ page });
    };

    handleChangeRowsPerPage = event => {
        this.setState({ page: 0, rowsPerPage: parseInt(event.target.value) });
    };

    componentDidMount() {
        window.scrollTo(0, 0);
        if(isEmpty(this.props.PROJECTS)){
            this.props.fetchProjects()
        }
        if(isEmpty(this.props.TIMESHEET)){
            this.props.fetchTimesheets()
        }
        if(isEmpty(this.props.STEPS)){
            this.props.fetchProjectSteps()
        }
    }

    handleClose = () => {
		this.setState({ 
            openForm: false,
            openUpdate: false,
            openDetails: false,
            openAddSpending: false,
            newStep: false,
            selected: {},
            selectedProject: {},
        });
    };    

    getProjectsList = () => {
        const { searchValue } = this.state;
        // const { rowsPerPage, page, searchValue } = this.state;
        const { PROJECTS, showArchived } = this.props;
        if (!isEmpty(PROJECTS)){
            let list = Object.values(PROJECTS)
            list = list.filter(project => showArchived ? project.project_status === "ARCHIVED" : project.project_status !== "ARCHIVED");
            if( !isEmpty(searchValue) ){
                list = list.filter( project => project.project_name.toLowerCase().includes(searchValue) );
            }

            // return list.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map(item =>
            return list.map(item => (
                <TableRow hover key={item.project_id} className="">
                    <TableCell>  
                        {this.props.isAdmin && !this.props.isUserPlus &&
                            <IconButton 
                                title="Ajouter une Etape" 
                                // color="primary"
                                onClick={ () => this.setState({newStep: true, selected: item}) }
                            >
                                <NoteAddRounded color="success" />
                            </IconButton>  
                        }
                    </TableCell> 
                    <TableCell
                        onClick={ () => this.setState({ openDetails: true, selectedProject: item})}
                    >
                        {item.project_name}
                    </TableCell>                                                   
                    <TableCell
                        onClick={ () => this.setState({ openDetails: true, selectedProject: item})}
                    >
                        {new Date(item.project_start_date).toLocaleDateString("fr-FR")}    
                    </TableCell>                                                  
                    <TableCell
                        onClick={ () => this.setState({ openDetails: true, selectedProject: item})}
                    >
                        {item.project_desc}
                    </TableCell> 
                    <TableCell
                        onClick={ () => this.setState({ openDetails: true, selectedProject: item})}
                    >
                        {item.project_status === "PLANNED" ? "Planifié" : item.project_status === "STARTED" ? "Démarré" : item.project_status === "FINISHED" ? "Terminé" : item.project_status === "ARCHIVED" ? "Archivé" : item.project_status || "Planifié"}
                    </TableCell>
                    <TableCell>
                         
                        {/* <IconButton 
                            title="Retirer" 
                            // color="primary"
                            // onClick={ () => this.setState({openRemoveSpending: true, selected: item}) }
                        >
                            <RemoveCircleOutlineRounded color="error" />
                        </IconButton>     */}
                        <IconButton 
                            title="Modifier" 
                            onClick={ () => this.setState({openUpdate: true, selected: item}) }
                            color="secondary"
                        >
                            <Edit />
                        </IconButton>    
                        {this.props.isAdmin && !this.props.isUserPlus &&
                            <IconButton 
                                title="Ajouter" 
                                color="primary"
                                onClick={ () => this.setState({openAddSpending: true, selected: item}) }
                            >
                                <AddCircleRounded />
                            </IconButton>  
                        }
                    </TableCell>                                                   
                                                                      
                </TableRow>
            ) )
        }
    }

    handleChange = (e) => {
        const { value } = e.target;

        this.setState({
            "searchValue": value.toLowerCase()
        })
    }

    render() {
        const { openForm, openUpdate, selected, openDetails, selectedProject, openAddSpending, newStep } = this.state;
        const { showArchived } = this.props;
        return (
            <div>
                {openForm &&
                    <ProjectForm open={openForm} handleClose={this.handleClose} {...this.props} />
                }
                {openUpdate && !isEmpty(selected) &&
                    <ProjectForm 
                        update 
                        project={selected} 
                        open={openUpdate} 
                        handleClose={this.handleClose} 
                        {...this.props} 
                    />
                }
                {openDetails && !isEmpty(selectedProject) &&
                    <ProjectSingle
                        open={openDetails} 
                        project={selectedProject}
                        handleClose={this.handleClose} 
                        {...this.props} 
                    />
                }
                {openAddSpending && !isEmpty(selected) &&
                    <AddSpending
                        open={openAddSpending} 
                        project={selected}
                        handleClose={this.handleClose} 
                        {...this.props} 
                    />
                }
                {newStep && !isEmpty(selected) &&
                    <ProjectStepForm open={newStep} handleClose={this.handleClose} {...this.props} {...selected} />
                }
              
                {/* <Typography variant="h6" id="tableTitle">
                    Liste des Projets
                </Typography> */}

                <TitleWithEndAction
                    title={showArchived ? "Projets Archivés" : "Liste des Projets"}
                    action={() => this.props.openFormDownloadAll("/extract/projects")}
                    actionTitle={showArchived ? "Export Projets Archivés" : "Liste des Projets"} 
                    disabled={this.props.downloading}
                >
                    {/* <IconButton color="primary" onClick={() => this.props.openFormDownloadAll("/extract/projects")} title="Liste Projets" disabled={this.props.downloading}>
                        <CloudDownloadRounded />
                    </IconButton> */}
                    {!showArchived && (
                        <>
                            <Fab
                                color="secondary"
                                variant="contained"
                                onClick={() => this.setState({ openForm: true })} title="Nouveau Projet"
                                size="small"
                                title="Nouveau Projet"
                            >
                                <AddRounded />
                            </Fab>
                            <span> </span>
                            <Fab
                                color="primary"
                                variant="contained"
                                onClick={() => this.props.openFormDownload("/extract/timesheets/project/MOD", "")}
                                size="small"
                                title="Hommes / Jour"
                                disabled={this.props.downloading}
                            >
                                <EngineeringRounded />
                            </Fab>
                            <span> </span>
                        </>
                    )}
                    {!showArchived ? (
                        <Fab
                            color="primary"
                            variant="contained"
                            onClick={() => this.props.history.push("/admin/projects_archived")}
                            size="small"
                            title="Projets Archivés"
                        >
                            <Inventory2Rounded />
                        </Fab>
                    ) : (
                        <Fab
                            color="primary"
                            variant="contained"
                            onClick={() => this.props.history.push("/admin/projects")}
                            size="small"
                            title="Liste des Projets"
                        >
                            <FormatListBulletedRounded />
                        </Fab>
                    )}
                </TitleWithEndAction>


                <Box >
                {/* <Box style={{ display:"flex", justifyContent:"space-between", alignItems: "center"}}> */}
                    <SearchBar 
                        handleChange={this.handleChange} 
                        label="Projet"
                        searchValue={this.state.searchValue}
                    />
                    
                    {/* <Button 
                        variant="contained" 
                        color="secondary" 
                        onClick={() => this.setState({ openForm: true })} title="Nouveau Projet"
                        startIcon={
                            <AddCircleIcon />
                        }
                    >
                        Ajouter
                    </Button> */}
                    {/* <IconButton color="primary" onClick={ () => this.props.handleDownload("/extract/projects", "MJB_projects.csv") } disabled={this.props.downloading}>
                        <CloudDownloadRounded />
                    </IconButton> */}
                    {/* <IconButton color="primary" onClick={() => this.props.openFormDownloadAll("/extract/projects")} title="Télécharger" disabled={this.props.downloading}>
                        <CloudDownloadRounded />
                    </IconButton> */}
                </Box>

                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell>Etapes</TableCell>
                            <TableCell>Nom</TableCell>
                            <TableCell>Démarrage</TableCell>
                            <TableCell>Description</TableCell>
                            <TableCell>Statut</TableCell>
                            <TableCell>Modifier {this.props.isAdmin && !this.props.isUserPlus && "/ Ajouter Dépenses"}</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {this.getProjectsList()}
                    </TableBody>
                    {/* {size(PROJECTS) > 10 &&
                        <TableFooter>
                            <TableRow>
                                <TablePagination
                                    rowsPerPageOptions={[10, 15]}
                                    colSpan={2}
                                    count={size(PROJECTS)}
                                    rowsPerPage={rowsPerPage}
                                    page={page}
                                    SelectProps={{
                                        native: true,
                                    }}
                                    onPageChange={this.handleChangePage}
                                    onRowsPerPageChange={this.handleChangeRowsPerPage}
                                    ActionsComponent={Pagination}
                                />
                            </TableRow>
                        </TableFooter>
                    } */}
                </Table> 
            </div>
        );
    }
}

ProjectsList.defaultProps = {
    showArchived: false,
};

export default withRouter(ProjectsList);